export const songQueryVarieties = {
  rotation_category: 1,
  sound_code: 2,
};
